import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const Image = ({ alt, fallbackSrc, placeholderSrc, src, styles }) => {
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    const srcUrl = src || fallbackSrc;

    if (srcUrl) setImgSrc(srcUrl);
  }, [fallbackSrc, src]);

  return <img alt={alt} css={styles} src={imgSrc || placeholderSrc} />;
};

Image.propTypes = {
  alt: PropTypes.string,
  fallbackSrc: PropTypes.string,
  placeholderSrc: PropTypes.string,
  src: PropTypes.string.isRequired,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

Image.defaultProps = {
  alt: 'image not available',
  fallbackSrc: '',
  placeholderSrc:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
  styles: null,
};

export default Image;
